import { useState } from 'react';
import { FolderPlus, Pencil, Trash2, Check, X } from 'lucide-react';
import ColorPalette from './ColorPalette';
import { FOLDER_COLORS } from '../../useFlowList';

export default function FoldersModal({ folders, folderCounts, onClose, onCreate, onSave, onDelete }) {
  const [newFolderName, setNewFolderName] = useState('');
  const [newFolderColor, setNewFolderColor] = useState(FOLDER_COLORS[0]);
  const [creating, setCreating] = useState(false);

  const [editingFolderId, setEditingFolderId] = useState(null);
  const [editFolderName, setEditFolderName] = useState('');
  const [editFolderColor, setEditFolderColor] = useState(FOLDER_COLORS[0]);

  async function handleCreate() {
    if (!newFolderName.trim() || creating) return;
    setCreating(true);
    const folder = await onCreate(newFolderName, newFolderColor);
    if (folder) setNewFolderName('');
    setCreating(false);
  }

  function startEdit(folder) {
    setEditingFolderId(folder.id);
    setEditFolderName(folder.name);
    setEditFolderColor(folder.color || FOLDER_COLORS[0]);
  }

  async function handleSave(folder) {
    if (!editFolderName.trim()) return;
    const updated = await onSave(folder, { name: editFolderName, color: editFolderColor });
    if (updated) setEditingFolderId(null);
  }

  return (
    <div className="manage-bots-modal-overlay" onClick={onClose}>
      <div className="manage-bots-modal" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
        <div className="manage-bots-modal-header">
          <h3><FolderPlus size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} /> Pastas</h3>
          <button className="manage-bots-close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Criar nova */}
        <label className="text-xs font-bold text-white/40 uppercase tracking-wider mb-2 block">
          Nova pasta
        </label>
        <div className="flex items-center gap-2">
          <input
            className="input3 w-full"
            placeholder="Nome da pasta"
            value={newFolderName}
            onChange={e => setNewFolderName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleCreate()}
            autoFocus
          />
          <button className="btn-primary flex-none" onClick={handleCreate} disabled={!newFolderName.trim() || creating}>
            {creating ? <i className="fas fa-spinner fa-spin" /> : 'Criar'}
          </button>
        </div>
        <div className="mt-2">
          <ColorPalette value={newFolderColor} onChange={setNewFolderColor} />
        </div>

        {/* Existentes */}
        {folders.length > 0 && (
          <>
            <label className="text-xs font-bold text-white/40 uppercase tracking-wider mb-2 mt-5 block">
              Suas pastas
            </label>
            <div className="flex flex-col gap-2">
              {folders.map(folder => (
                <div key={folder.id} className="flex flex-col gap-2 bg-white/[0.03] border border-white/[0.06] rounded-xl px-3 py-2">
                  {editingFolderId === folder.id ? (
                    <>
                      <div className="flex items-center gap-2">
                        <input
                          className="input3 w-full"
                          value={editFolderName}
                          onChange={e => setEditFolderName(e.target.value)}
                          onKeyDown={e => e.key === 'Enter' && handleSave(folder)}
                          autoFocus
                        />
                        <button className="action-btn action-btn--blue" title="Salvar" onClick={() => handleSave(folder)}>
                          <Check size={14} />
                        </button>
                        <button className="action-btn" title="Cancelar" onClick={() => setEditingFolderId(null)}>
                          <X size={14} />
                        </button>
                      </div>
                      <ColorPalette value={editFolderColor} onChange={setEditFolderColor} />
                    </>
                  ) : (
                    <div className="flex items-center justify-between gap-2">
                      <span className="flex items-center gap-2 text-sm text-white min-w-0" style={{ color: folder.color }}>
                        <span className="truncate">{folder.name}</span>
                        <span className="text-white/30 text-xs">({folderCounts[folder.id] || 0})</span>
                      </span>
                      <span className="flex items-center gap-1 flex-none">
                        <button className="action-btn" title="Editar" onClick={() => startEdit(folder)}>
                          <Pencil size={13} />
                        </button>
                        <button className="action-btn action-btn--red" title="Excluir" onClick={() => onDelete(folder)}>
                          <Trash2 size={13} />
                        </button>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        <div className="manage-bots-footer" style={{ marginTop: '1rem' }}>
          <div />
          <div className="manage-bots-footer-actions">
            <button className="btn-secondary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
